import React, { useRef, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import "./LanguageSwitcher.scss";

import useOutsideClick from "hooks/useOutSideClick";

import { ReactComponent as LanguageIcon } from 'static/icons/language.svg'
import { ReactComponent as Triangle } from "static/icons/triangle.svg";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const languageRef = useRef();

  const [isLanguageDropdownActive, setIsLanguageDropdownActive] = useState(false);

  const currentLanguage = useMemo(() => {
    switch (localStorage.getItem('language')) {
      case 'en': return "En"
      case 'he': return "עב"
      default: return "En"
    }
  }, [localStorage.getItem('language')])

  useOutsideClick(languageRef, () => {
    setIsLanguageDropdownActive(false);
  });

  const handleLanguageChange = (curentLanguage) => {
    i18n.changeLanguage(curentLanguage);
    localStorage.setItem('language', curentLanguage)
    window.location.reload();
  };

  return (
    <div className="language-switcher">
      <div
        ref={languageRef}
        className="sing-in__language-curent-language-wrapper"
        onClick={() => setIsLanguageDropdownActive(prevState => !prevState)}
      >
        <LanguageIcon />
        <div className="sing-in__language-curent-language">{currentLanguage.toUpperCase()}</div>
        <Triangle />

        {isLanguageDropdownActive &&
          <div className="sing-in__language-dropdown">
            <div
              className="sing-in__language-dropdown__item"
              onClick={() => handleLanguageChange('en')}
            >
              English
            </div>
            <div
              className="sing-in__language-dropdown__item"
              onClick={() => handleLanguageChange('he')}
            >
              עברית
            </div>
          </div>
        }
      </div>
    </div>
  );
};

export default LanguageSwitcher;
